export const defaultTranslations = {
	en: {
		home: {
			title: "Home",
			search: "Search",
			start_new_chat: "Start new chat",
			start_new_call: "Start new call",
		},
		conversations: {
			title: "Conversations",
			chats: "Chats",
			calls: "Calls",
			live_chat: "Live Chat",
			report_issue: "Report issue",
			no_conversations_yet: "No conversations yet",
			input_placeholder: "Ask me anything",
			ended_conversation: "This conversation has ended, please start a new conversation",
			no_reply: "No reply yet",
			recent_message: "Recent message",
			no_recent_messages: "No recent messages",
			sources: "Sources",
			ai_agent: "AI agent",
			ai_disclaimer: "The AI agent can make mistakes. Verify important information.",
		},
		tickets: {
			title: "Tickets",
			open: "Open",
			in_progress: "In progress",
			waiting_on_customer: "Waiting for your reply",
			closed: "Closed",
			no_recent_tickets: "No recent tickets",
		},
		help: {
			title: "Help",
			no_articles_found: "No articles found",
			no_collections_found: "No collections found",
			article_unavailable: "This article could not be loaded",
			articles_from_collection: "Articles from collection",
			no_faq_found: "No FAQs found",
			invalid_email: "Please enter a valid email address",
			invalid_number: "Please enter a valid number",
			invalid_image: "Invalid image type. Allowed: jpeg, jpg, png",
			large_image: "Image too large. Max 2MB allowed",
		},
		file: {
			uploading: "Uploading...",
			scanning: "Scanning for viruses...",
			ready: "Ready to send",
			quarantined: "File blocked — potential threat detected",
			scanFailed: "Scan failed — please try again",
			tooLarge: "File too large (max 2MB): {name}",
			unsupportedType: "Unsupported file type: {name}",
			rateLimited: "Daily upload limit reached. Try again tomorrow.",
			attachFile: "Attach file",
			dragAndDrop: "Drop files here",
			removeFile: "Remove file",
			maxFilesReached: "Maximum {max} files allowed",
		},
		time: {
			just_now: "Just now",
			today: "Today",
			yesterday: "Yesterday",
			ago: "ago",
			day: "day",
			days: "days",
			hour: "hour",
			hours: "hours",
			minute: "minute",
			minutes: "minutes",
		},
		feedback: {
			row_label: "Rate this answer",
			helpful: "Helpful",
			not_helpful: "Not helpful",
			copy: "Copy",
			copied: "Copied",
			title_up: "What was good about it?",
			title_down: "What was wrong with it?",
			skip: "Skip",
			send: "Send",
			thanks: "Thanks — that helps us improve.",
			other_placeholder: "Tell us more (optional)",
			counter: "{count}/{max}",
			error_rate_limited: "You've sent a lot of feedback just now — try again in a minute.",
			error_unavailable: "Feedback isn't available for this message.",
			error_invalid: "That feedback couldn't be sent. Please check it and try again.",
			error_retry_later: "Couldn't send your feedback. Please try again.",
			chip_accurate: "Accurate",
			chip_relevant: "Relevant",
			chip_clear: "Clear",
			chip_complete: "Complete",
			chip_well_sourced: "Well-sourced",
			chip_friendly_tone: "Friendly tone",
			chip_inaccurate: "Inaccurate",
			chip_irrelevant: "Irrelevant",
			chip_confusing: "Confusing",
			chip_incomplete: "Incomplete",
			chip_outdated: "Outdated",
			chip_wrong_tone: "Wrong tone",
			chip_other: "Other",
		},
		// spec-langchain-native-runtime 08c (WIDGET.TRACE.*): the agent's steps in the reply bubble.
		// `summary_<plural category>` is chosen by Intl.PluralRules; `summary` is the fallback.
		trace: {
			working: "Working on it…",
			thinking: "Thinking…",
			summary: "{count} steps",
			summary_one: "{count} step",
			show: "Show steps",
			hide: "Hide steps",
			failed: "Step failed",
		},
		// chat-experience 06c: the agent's prompts on the empty chat page and behind the composer's `+`.
		starters: {
			title: "Suggested questions",
			send: "Send: {label}",
			collection: "{name}, {count} prompts",
			menu: "Add to this message",
			upload: "Upload file",
			prompts: "Prompts",
			back: "Back",
		},
		// chat-experience 11: the chat page's transcript and composer. The other twelve languages fall
		// through to these English strings (useWidgetMsg) until they are translated by a person.
		chat: {
			send: "Send",
			send_failed: "Message not sent",
			retry: "Retry",
			offline: "You are offline",
			back_online: "Back online",
			jump_to_latest: "Jump to latest",
			new_messages: "{count} new",
			copy_message: "Copy message",
			copied: "Copied",
			reply_started: "Assistant is replying",
			reply_finished: "Reply received",
			copy_ref: "Copy reference ID",
			ref_copied: "Reference copied",
		},
		// RT09b (spec-langchain-native-runtime 09b): the reply's suggested next step.
		suggestions: {
			title: "Suggested next steps",
			send: "Send: {label}",
		},
		// spec-widget-mcp 05: the six Tier-1 widgets (WIDGET.NATIVE.* in the spec; this widget's msg()
		// reads `section.key`, so the namespace is `widget`).
		widget: {
			other: "Other",
			other_input: "Your answer",
			other_placeholder: "Type your answer",
			submit: "Send",
			next: "Next",
			back: "Back",
			required: "This field is required.",
			invalid: "This value is not valid.",
			sent: "Sent",
			submitted_at: "Sent at {time}",
			expired: "This is no longer available.",
			step_of: "Step {current} of {total}",
			times_in: "Times in {timezone}",
			passed: "passed",
			none: "None of these work",
			confirm: "Confirm",
			cancel: "Cancel",
			confirmed: "Confirmed",
			declined: "Declined",
			progress_step: "Step {current} of {total}: {label}",
			progress_done: "All {total} steps complete",
			select_placeholder: "Choose…",
			address_country: "Country",
			address_line1: "Address line 1",
			address_line2: "Address line 2 (optional)",
			address_city: "City",
			address_town: "Town or city",
			address_state: "State",
			address_province: "Province",
			address_county: "County",
			address_region: "Region",
			address_postcode: "Postal code",
			address_zip: "ZIP code",
			address_uk_postcode: "Postcode",
			address_eircode: "Eircode (optional)",
		},
	},

	uk: {
		home: {
			title: "Головна",
			search: "Пошук",
			start_new_chat: "Почати новий чат",
			start_new_call: "Почати дзвінок",
		},
		conversations: {
			title: "Розмови",
			chats: "Чати",
			calls: "Дзвінки",
			live_chat: "Онлайн чат",
			report_issue: "Повідомити про проблему",
			no_conversations_yet: "Розмов ще немає",
			input_placeholder: "Запитайте мене що завгодно",
			ended_conversation: "Цю розмову завершено, будь ласка, почніть нову",
			no_reply: "Відповіді ще немає",
			recent_message: "Останнє повідомлення",
			no_recent_messages: "Немає нових повідомлень",
			sources: "Джерела",
			ai_agent: "ШІ Агент",
			ai_disclaimer: "ШІ-агент може помилятися. Перевіряйте важливу інформацію.",
		},
		tickets: {
			title: "Тікети",
			open: "Новий",
			in_progress: "В роботі",
			waiting_on_customer: "Очікуємо на вашу відповідь",
			closed: "Вирішений",
			no_recent_tickets: "Немає нещодавніх тікетів",
		},
		help: {
			title: "Допомога",
			no_articles_found: "Статті не знайдено",
			no_collections_found: "Колекцій не знайдено",
			article_unavailable: "Не вдалося завантажити статтю",
			articles_from_collection: "Статті з колекції",
			no_faq_found: "Поширених запитань не знайдено",
			invalid_email: "Будь ласка, введіть коректну електронну адресу",
			invalid_number: "Будь ласка, введіть коректне число",
			invalid_image: "Неприпустимий тип зображення (jpeg, jpg, png)",
			large_image: "Зображення занадто велике (макс. 2 МБ)",
		},
		file: {
			uploading: "Завантаження...",
			scanning: "Перевірка на віруси...",
			ready: "Готово до відправки",
			quarantined: "Файл заблоковано — виявлено потенційну загрозу",
			scanFailed: "Перевірка не вдалась — спробуйте ще раз",
			tooLarge: "Файл занадто великий (макс. 2 МБ): {name}",
			unsupportedType: "Непідтримуваний тип файлу: {name}",
			rateLimited: "Досягнуто денний ліміт завантажень. Спробуйте завтра.",
			attachFile: "Прикріпити файл",
			dragAndDrop: "Перетягніть файли сюди",
			removeFile: "Видалити файл",
			maxFilesReached: "Максимум {max} файлів дозволено",
		},
		time: {
			just_now: "Щойно",
			today: "Сьогодні",
			yesterday: "Вчора",
			ago: "тому",
			day: "день",
			days: "днів",
			hour: "год",
			hours: "год",
			minute: "хв",
			minutes: "хв",
		},
		feedback: {
			row_label: "Оцініть цю відповідь",
			helpful: "Корисно",
			not_helpful: "Не корисно",
			copy: "Копіювати",
			copied: "Скопійовано",
			title_up: "Що було добре?",
			title_down: "Що було не так?",
			skip: "Пропустити",
			send: "Надіслати",
			thanks: "Дякуємо — це допомагає нам ставати кращими.",
			other_placeholder: "Розкажіть більше (необов'язково)",
			counter: "{count}/{max}",
			error_rate_limited: "Ви щойно надіслали багато відгуків — спробуйте за хвилину.",
			error_unavailable: "Відгук для цього повідомлення недоступний.",
			error_invalid: "Не вдалося надіслати відгук. Перевірте його та спробуйте ще раз.",
			error_retry_later: "Не вдалося надіслати відгук. Спробуйте ще раз.",
			chip_accurate: "Точно",
			chip_relevant: "Доречно",
			chip_clear: "Зрозуміло",
			chip_complete: "Повно",
			chip_well_sourced: "З надійними джерелами",
			chip_friendly_tone: "Дружній тон",
			chip_inaccurate: "Неточно",
			chip_irrelevant: "Недоречно",
			chip_confusing: "Незрозуміло",
			chip_incomplete: "Неповно",
			chip_outdated: "Застаріло",
			chip_wrong_tone: "Невдалий тон",
			chip_other: "Інше",
		},
		trace: {
			working: "Працюю над цим…",
			thinking: "Думаю…",
			summary: "{count} кроків",
			summary_one: "{count} крок",
			summary_few: "{count} кроки",
			summary_many: "{count} кроків",
			show: "Показати кроки",
			hide: "Сховати кроки",
			failed: "Крок не вдався",
		},
		starters: {
			title: "Пропоновані запитання",
			send: "Надіслати: {label}",
			collection: "{name}, підказок: {count}",
			menu: "Додати до повідомлення",
			upload: "Завантажити файл",
			prompts: "Підказки",
			back: "Назад",
		},
		chat: {
			send: "Надіслати",
			send_failed: "Повідомлення не надіслано",
			retry: "Повторити",
			offline: "Ви офлайн",
			back_online: "Знову онлайн",
			jump_to_latest: "До останніх",
			new_messages: "Нових: {count}",
			copy_message: "Копіювати повідомлення",
			copied: "Скопійовано",
			reply_started: "Асистент відповідає",
			reply_finished: "Відповідь отримано",
			copy_ref: "Копіювати ідентифікатор",
			ref_copied: "Ідентифікатор скопійовано",
		},
		// RT09b
		suggestions: {
			title: "Пропоновані наступні кроки",
			send: "Надіслати: {label}",
		},
		// spec-widget-mcp 05
		widget: {
			other: "Інше",
			other_input: "Ваша відповідь",
			other_placeholder: "Введіть відповідь",
			submit: "Надіслати",
			next: "Далі",
			back: "Назад",
			required: "Це поле обов’язкове.",
			invalid: "Недійсне значення.",
			sent: "Надіслано",
			submitted_at: "Надіслано о {time}",
			expired: "Це вже недоступно.",
			step_of: "Крок {current} з {total}",
			times_in: "Час: {timezone}",
			passed: "минув",
			none: "Жоден не підходить",
			confirm: "Підтвердити",
			cancel: "Скасувати",
			confirmed: "Підтверджено",
			declined: "Відхилено",
			progress_step: "Крок {current} з {total}: {label}",
			progress_done: "Усі кроки ({total}) завершено",
			select_placeholder: "Виберіть…",
			address_country: "Країна",
			address_line1: "Адреса, рядок 1",
			address_line2: "Адреса, рядок 2 (необов’язково)",
			address_city: "Місто",
			address_town: "Місто або селище",
			address_state: "Штат",
			address_province: "Провінція",
			address_county: "Графство",
			address_region: "Область",
			address_postcode: "Поштовий індекс",
			address_zip: "Індекс ZIP",
			address_uk_postcode: "Поштовий індекс",
			address_eircode: "Eircode (необов’язково)",
		},
	},

	es: {
		home: {
			title: "Inicio",
			search: "Buscar",
			start_new_chat: "Iniciar nuevo chat",
			start_new_call: "Iniciar nueva llamada",
		},
		conversations: {
			title: "Conversaciones",
			chats: "Chats",
			calls: "Llamadas",
			live_chat: "Chat en vivo",
			report_issue: "Reportar un problema",
			no_conversations_yet: "Aún no hay conversaciones",
			input_placeholder: "Pregúntame lo que quieras",
			ended_conversation: "Esta conversación ha finalizado, inicia una nueva",
			no_reply: "Aún no hay respuesta",
			recent_message: "Mensaje reciente",
			no_recent_messages: "No hay mensajes recientes",
			sources: "Fuentes",
			ai_agent: "Agente IA",
			ai_disclaimer: "El agente de IA puede cometer errores. Verifica la información importante.",
		},
		tickets: {
			title: "Tickets",
			open: "Abierto",
			in_progress: "En progreso",
			waiting_on_customer: "Esperando tu respuesta",
			closed: "Cerrado",
			no_recent_tickets: "No hay tickets recientes",
		},
		help: {
			title: "Ayuda",
			no_articles_found: "No se encontraron artículos",
			no_collections_found: "No se encontraron colecciones",
			articles_from_collection: "Artículos de la colección",
			no_faq_found: "No se encontraron preguntas frecuentes",
			invalid_email: "Por favor, introduce un correo electrónico válido",
			invalid_number: "Por favor, introduce un número válido",
			invalid_image: "Tipo de imagen no válido (jpeg, jpg, png)",
			large_image: "La imagen es demasiado grande (máx. 2 MB)",
		},
		file: {
			uploading: "Subiendo...",
			scanning: "Escaneando en busca de virus...",
			ready: "Listo para enviar",
			quarantined: "Archivo bloqueado — amenaza potencial detectada",
			scanFailed: "Escaneo fallido — inténtalo de nuevo",
			tooLarge: "Archivo demasiado grande (máx. 2MB): {name}",
			unsupportedType: "Tipo de archivo no soportado: {name}",
			rateLimited: "Límite diario de subidas alcanzado. Inténtalo mañana.",
			attachFile: "Adjuntar archivo",
			dragAndDrop: "Suelta los archivos aquí",
			removeFile: "Eliminar archivo",
			maxFilesReached: "Máximo {max} archivos permitidos",
		},
		time: {
			just_now: "Ahora mismo",
			today: "Hoy",
			yesterday: "Ayer",
			ago: "hace",
			day: "día",
			days: "días",
			hour: "hora",
			hours: "horas",
			minute: "minuto",
			minutes: "minutos",
		},
	},

	fr: {
		home: {
			title: "Accueil",
			search: "Rechercher",
			start_new_chat: "Démarrer un nouveau chat",
			start_new_call: "Démarrer un nouvel appel",
		},
		conversations: {
			title: "Conversations",
			chats: "Discussions",
			calls: "Appels",
			live_chat: "Chat en direct",
			report_issue: "Signaler un problème",
			no_conversations_yet: "Aucune conversation pour le moment",
			input_placeholder: "Posez-moi une question",
			ended_conversation: "Cette conversation est terminée, veuillez en démarrer une nouvelle",
			no_reply: "Pas encore de réponse",
			recent_message: "Message récent",
			no_recent_messages: "Aucun message récent",
			sources: "Sources",
			ai_agent: "Agent IA",
			ai_disclaimer: "L'agent IA peut faire des erreurs. Vérifiez les informations importantes.",
		},
		tickets: {
			title: "Tickets",
			open: "Ouvert",
			in_progress: "En cours",
			waiting_on_customer: "En attente de votre réponse",
			closed: "Fermé",
			no_recent_tickets: "Aucun ticket récent",
		},
		help: {
			title: "Aide",
			no_articles_found: "Aucun article trouvé",
			no_collections_found: "Aucune collection trouvée",
			article_unavailable: "Impossible de charger cet article",
			articles_from_collection: "Articles de la collection",
			no_faq_found: "Aucune FAQ trouvée",
			invalid_email: "Veuillez entrer une adresse e-mail valide",
			invalid_number: "Veuillez entrer un nombre valide",
			invalid_image: "Type d’image invalide (jpeg, jpg, png)",
			large_image: "Image trop volumineuse (max 2 Mo)",
		},
		file: {
			uploading: "T\u00e9l\u00e9chargement...",
			scanning: "Analyse antivirus en cours...",
			ready: "Pr\u00eat \u00e0 envoyer",
			quarantined: "Fichier bloqu\u00e9 \u2014 menace potentielle d\u00e9tect\u00e9e",
			scanFailed: "Analyse \u00e9chou\u00e9e \u2014 r\u00e9essayez",
			tooLarge: "Fichier trop volumineux (max 2 Mo) : {name}",
			unsupportedType: "Type de fichier non pris en charge : {name}",
			rateLimited: "Limite quotidienne atteinte. R\u00e9essayez demain.",
			attachFile: "Joindre un fichier",
			dragAndDrop: "D\u00e9posez les fichiers ici",
			removeFile: "Supprimer le fichier",
			maxFilesReached: "Maximum {max} fichiers autoris\u00e9s",
		},
		time: {
			just_now: "À l’instant",
			today: "Aujourd’hui",
			yesterday: "Hier",
			ago: "il y a",
			day: "jour",
			days: "jours",
			hour: "heure",
			hours: "heures",
			minute: "minute",
			minutes: "minutes",
		},
		// spec-widget-mcp 05
		widget: {
			other: "Autre",
			other_input: "Votre réponse",
			other_placeholder: "Saisissez votre réponse",
			submit: "Envoyer",
			next: "Suivant",
			back: "Retour",
			required: "Ce champ est obligatoire.",
			invalid: "Cette valeur n’est pas valide.",
			sent: "Envoyé",
			submitted_at: "Envoyé à {time}",
			expired: "Ceci n’est plus disponible.",
			step_of: "Étape {current} sur {total}",
			times_in: "Heures : {timezone}",
			passed: "passé",
			none: "Aucun ne me convient",
			confirm: "Confirmer",
			cancel: "Annuler",
			confirmed: "Confirmé",
			declined: "Refusé",
			progress_step: "Étape {current} sur {total} : {label}",
			progress_done: "Les {total} étapes sont terminées",
			select_placeholder: "Choisir…",
			address_country: "Pays",
			address_line1: "Adresse, ligne 1",
			address_line2: "Adresse, ligne 2 (facultatif)",
			address_city: "Ville",
			address_town: "Ville ou localité",
			address_state: "État",
			address_province: "Province",
			address_county: "Comté",
			address_region: "Région",
			address_postcode: "Code postal",
			address_zip: "Code ZIP",
			address_uk_postcode: "Code postal",
			address_eircode: "Eircode (facultatif)",
		},
	},

	de: {
		home: {
			title: "Startseite",
			search: "Suchen",
			start_new_chat: "Neuen Chat starten",
			start_new_call: "Neuen Anruf starten",
		},
		conversations: {
			title: "Unterhaltungen",
			chats: "Chats",
			calls: "Anrufe",
			live_chat: "Live-Chat",
			report_issue: "Problem melden",
			no_conversations_yet: "Noch keine Unterhaltungen",
			input_placeholder: "Frag mich irgendetwas",
			ended_conversation: "Diese Unterhaltung ist beendet, bitte starte eine neue",
			no_reply: "Noch keine Antwort",
			recent_message: "Letzte Nachricht",
			no_recent_messages: "Keine aktuellen Nachrichten",
			sources: "Quellen",
			ai_agent: "KI-Agent",
			ai_disclaimer: "Der KI-Agent kann Fehler machen. Überprüfe wichtige Informationen.",
		},
		tickets: {
			title: "Tickets",
			open: "Offen",
			in_progress: "In Bearbeitung",
			waiting_on_customer: "Wartet auf deine Antwort",
			closed: "Geschlossen",
			no_recent_tickets: "Keine aktuellen Tickets",
		},
		help: {
			title: "Hilfe",
			no_articles_found: "Keine Artikel gefunden",
			no_collections_found: "Keine Sammlungen gefunden",
			articles_from_collection: "Artikel aus der Sammlung",
			no_faq_found: "Keine FAQs gefunden",
			invalid_email: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
			invalid_number: "Bitte geben Sie eine gültige Zahl ein",
			invalid_image: "Ungültiger Bildtyp (jpeg, jpg, png)",
			large_image: "Bild ist zu groß (max. 2 MB)",
		},
		file: {
			uploading: "Wird hochgeladen...",
			scanning: "Virenscan l\u00e4uft...",
			ready: "Bereit zum Senden",
			quarantined: "Datei blockiert \u2014 potenzielle Bedrohung erkannt",
			scanFailed: "Scan fehlgeschlagen \u2014 bitte erneut versuchen",
			tooLarge: "Datei zu gro\u00df (max. 2 MB): {name}",
			unsupportedType: "Nicht unterst\u00fctzter Dateityp: {name}",
			rateLimited: "T\u00e4gliches Upload-Limit erreicht. Morgen erneut versuchen.",
			attachFile: "Datei anh\u00e4ngen",
			dragAndDrop: "Dateien hier ablegen",
			removeFile: "Datei entfernen",
			maxFilesReached: "Maximal {max} Dateien erlaubt",
		},
		time: {
			just_now: "Gerade eben",
			today: "Heute",
			yesterday: "Gestern",
			ago: "vor",
			day: "Tag",
			days: "Tage",
			hour: "Stunde",
			hours: "Stunden",
			minute: "Minute",
			minutes: "Minuten",
		},
	},

	nl: {
		home: {
			title: "Home",
			search: "Zoeken",
			start_new_chat: "Nieuwe chat starten",
			start_new_call: "Nieuwe oproep starten",
		},
		conversations: {
			title: "Gesprekken",
			chats: "Chats",
			calls: "Oproepen",
			live_chat: "Live chat",
			report_issue: "Probleem melden",
			no_conversations_yet: "Nog geen gesprekken",
			input_placeholder: "Vraag me alles",
			ended_conversation: "Dit gesprek is beëindigd, start een nieuw gesprek",
			no_reply: "Nog geen antwoord",
			recent_message: "Recent bericht",
			no_recent_messages: "Geen recente berichten",
			sources: "Bronnen",
			ai_agent: "AI-agent",
			ai_disclaimer: "De AI-agent kan fouten maken. Controleer belangrijke informatie.",
		},
		tickets: {
			title: "Tickets",
			open: "Open",
			in_progress: "In behandeling",
			waiting_on_customer: "Wacht op je reactie",
			closed: "Gesloten",
			no_recent_tickets: "Geen recente tickets",
		},
		help: {
			title: "Help",
			no_articles_found: "Geen artikelen gevonden",
			no_collections_found: "Geen collecties gevonden",
			articles_from_collection: "Artikelen uit de collectie",
			no_faq_found: "Geen veelgestelde vragen gevonden",
			invalid_email: "Voer een geldig e-mailadres in",
			invalid_number: "Voer een geldig nummer in",
			invalid_image: "Ongeldig afbeeldingsformaat (jpeg, jpg, png)",
			large_image: "Afbeelding te groot (max. 2 MB)",
		},
		file: {
			uploading: "Uploaden...",
			scanning: "Scannen op virussen...",
			ready: "Klaar om te verzenden",
			quarantined: "Bestand geblokkeerd \u2014 mogelijke dreiging gedetecteerd",
			scanFailed: "Scan mislukt \u2014 probeer opnieuw",
			tooLarge: "Bestand te groot (max. 2 MB): {name}",
			unsupportedType: "Niet-ondersteund bestandstype: {name}",
			rateLimited: "Dagelijkse uploadlimiet bereikt. Probeer morgen opnieuw.",
			attachFile: "Bestand bijvoegen",
			dragAndDrop: "Sleep bestanden hierheen",
			removeFile: "Bestand verwijderen",
			maxFilesReached: "Maximaal {max} bestanden toegestaan",
		},
		time: {
			just_now: "Zojuist",
			today: "Vandaag",
			yesterday: "Gisteren",
			ago: "geleden",
			day: "dag",
			days: "dagen",
			hour: "uur",
			hours: "uur",
			minute: "minuut",
			minutes: "minuten",
		},
	},

	pt: {
		home: {
			title: "Início",
			search: "Pesquisar",
			start_new_chat: "Iniciar novo chat",
			start_new_call: "Iniciar nova chamada",
		},
		conversations: {
			title: "Conversas",
			chats: "Chats",
			calls: "Chamadas",
			live_chat: "Chat ao vivo",
			report_issue: "Reportar problema",
			no_conversations_yet: "Ainda não há conversas",
			input_placeholder: "Pergunte o que quiser",
			ended_conversation: "Esta conversa foi encerrada, inicie uma nova",
			no_reply: "Ainda sem resposta",
			recent_message: "Mensagem recente",
			no_recent_messages: "Nenhuma mensagem recente",
			sources: "Fontes",
			ai_agent: "Agente de IA",
			ai_disclaimer: "O agente de IA pode cometer erros. Verifique as informações importantes.",
		},
		tickets: {
			title: "Tickets",
			open: "Aberto",
			in_progress: "Em andamento",
			waiting_on_customer: "Aguardando sua resposta",
			closed: "Fechado",
			no_recent_tickets: "Nenhum ticket recente",
		},
		help: {
			title: "Ajuda",
			no_articles_found: "Nenhum artigo encontrado",
			no_collections_found: "Nenhuma coleção encontrada",
			articles_from_collection: "Artigos da coleção",
			no_faq_found: "Nenhuma FAQ encontrada",
			invalid_email: "Por favor, insira um e-mail válido",
			invalid_number: "Por favor, insira um número válido",
			invalid_image: "Tipo de imagem inválido (jpeg, jpg, png)",
			large_image: "Imagem muito grande (máx. 2 MB)",
		},
		file: {
			uploading: "Enviando...",
			scanning: "Verificando v\u00edrus...",
			ready: "Pronto para enviar",
			quarantined: "Arquivo bloqueado \u2014 amea\u00e7a potencial detectada",
			scanFailed: "Verifica\u00e7\u00e3o falhou \u2014 tente novamente",
			tooLarge: "Arquivo muito grande (m\u00e1x. 2 MB): {name}",
			unsupportedType: "Tipo de arquivo n\u00e3o suportado: {name}",
			rateLimited: "Limite di\u00e1rio atingido. Tente amanh\u00e3.",
			attachFile: "Anexar arquivo",
			dragAndDrop: "Solte os arquivos aqui",
			removeFile: "Remover arquivo",
			maxFilesReached: "M\u00e1ximo de {max} arquivos permitidos",
		},
		time: {
			just_now: "Agora mesmo",
			today: "Hoje",
			yesterday: "Ontem",
			ago: "há",
			day: "dia",
			days: "dias",
			hour: "hora",
			hours: "horas",
			minute: "minuto",
			minutes: "minutos",
		},
	},

	it: {
		home: {
			title: "Home",
			search: "Cerca",
			start_new_chat: "Avvia nuova chat",
			start_new_call: "Avvia nuova chiamata",
		},
		conversations: {
			title: "Conversazioni",
			chats: "Chat",
			calls: "Chiamate",
			live_chat: "Chat dal vivo",
			report_issue: "Segnala un problema",
			no_conversations_yet: "Nessuna conversazione ancora",
			input_placeholder: "Chiedimi qualsiasi cosa",
			ended_conversation: "Questa conversazione è terminata, avviane una nuova",
			no_reply: "Nessuna risposta ancora",
			recent_message: "Messaggio recente",
			no_recent_messages: "Nessun messaggio recente",
			sources: "Fonti",
			ai_agent: "Agente IA",
			ai_disclaimer: "L'agente IA può commettere errori. Verifica le informazioni importanti.",
		},
		tickets: {
			title: "Ticket",
			open: "Aperto",
			in_progress: "In corso",
			waiting_on_customer: "In attesa della tua risposta",
			closed: "Chiuso",
			no_recent_tickets: "Nessun ticket recente",
		},
		help: {
			title: "Aiuto",
			no_articles_found: "Nessun articolo trovato",
			no_collections_found: "Nessuna raccolta trovata",
			articles_from_collection: "Articoli dalla raccolta",
			no_faq_found: "Nessuna FAQ trovata",
			invalid_email: "Inserisci un indirizzo email valido",
			invalid_number: "Inserisci un numero valido",
			invalid_image: "Tipo di immagine non valido (jpeg, jpg, png)",
			large_image: "Immagine troppo grande (max 2 MB)",
		},
		file: {
			uploading: "Caricamento...",
			scanning: "Scansione antivirus...",
			ready: "Pronto per l'invio",
			quarantined: "File bloccato \u2014 potenziale minaccia rilevata",
			scanFailed: "Scansione fallita \u2014 riprova",
			tooLarge: "File troppo grande (max 2 MB): {name}",
			unsupportedType: "Tipo di file non supportato: {name}",
			rateLimited: "Limite giornaliero raggiunto. Riprova domani.",
			attachFile: "Allega file",
			dragAndDrop: "Trascina i file qui",
			removeFile: "Rimuovi file",
			maxFilesReached: "Massimo {max} file consentiti",
		},
		time: {
			just_now: "Proprio ora",
			today: "Oggi",
			yesterday: "Ieri",
			ago: "fa",
			day: "giorno",
			days: "giorni",
			hour: "ora",
			hours: "ore",
			minute: "minuto",
			minutes: "minuti",
		},
	},

	pl: {
		home: {
			title: "Strona główna",
			search: "Szukaj",
			start_new_chat: "Rozpocznij nowy czat",
			start_new_call: "Rozpocznij nowe połączenie",
		},
		conversations: {
			title: "Rozmowy",
			chats: "Czaty",
			calls: "Połączenia",
			live_chat: "Czat na żywo",
			report_issue: "Zgłoś problem",
			no_conversations_yet: "Brak rozmów",
			input_placeholder: "Zapytaj mnie o cokolwiek",
			ended_conversation: "Ta rozmowa została zakończona, rozpocznij nową",
			no_reply: "Brak odpowiedzi",
			recent_message: "Ostatnia wiadomość",
			no_recent_messages: "Brak ostatnich wiadomości",
			sources: "Źródła",
			ai_agent: "Agent AI",
			ai_disclaimer: "Agent AI może popełniać błędy. Zweryfikuj ważne informacje.",
		},
		tickets: {
			title: "Zgłoszenia",
			open: "Otwarte",
			in_progress: "W trakcie",
			waiting_on_customer: "Czekamy na Twoją odpowiedź",
			closed: "Zamknięte",
			no_recent_tickets: "Brak ostatnich zgłoszeń",
		},
		help: {
			title: "Pomoc",
			no_articles_found: "Nie znaleziono artykułów",
			no_collections_found: "Nie znaleziono kolekcji",
			articles_from_collection: "Artykuły z kolekcji",
			no_faq_found: "Nie znaleziono FAQ",
			invalid_email: "Wprowadź poprawny adres e-mail",
			invalid_number: "Wprowadź poprawną liczbę",
			invalid_image: "Nieprawidłowy typ obrazu (jpeg, jpg, png)",
			large_image: "Obraz jest za duży (maks. 2 MB)",
		},
		file: {
			uploading: "Przesy\u0142anie...",
			scanning: "Skanowanie w poszukiwaniu wirus\u00f3w...",
			ready: "Gotowy do wys\u0142ania",
			quarantined: "Plik zablokowany \u2014 wykryto potencjalne zagro\u017cenie",
			scanFailed: "Skanowanie nie powiod\u0142o si\u0119 \u2014 spr\u00f3buj ponownie",
			tooLarge: "Plik za du\u017cy (maks. 2 MB): {name}",
			unsupportedType: "Nieobs\u0142ugiwany typ pliku: {name}",
			rateLimited: "Osi\u0105gni\u0119to dzienny limit. Spr\u00f3buj jutro.",
			attachFile: "Do\u0142\u0105cz plik",
			dragAndDrop: "Upu\u015b\u0107 pliki tutaj",
			removeFile: "Usu\u0144 plik",
			maxFilesReached: "Maksymalnie {max} plik\u00f3w dozwolonych",
		},
		time: {
			just_now: "Przed chwilą",
			today: "Dzisiaj",
			yesterday: "Wczoraj",
			ago: "temu",
			day: "dzień",
			days: "dni",
			hour: "godzina",
			hours: "godziny",
			minute: "minuta",
			minutes: "minuty",
		},
	},

	tr: {
		home: {
			title: "Ana Sayfa",
			search: "Ara",
			start_new_chat: "Yeni sohbet başlat",
			start_new_call: "Yeni arama başlat",
		},
		conversations: {
			title: "Konuşmalar",
			chats: "Sohbetler",
			calls: "Aramalar",
			live_chat: "Canlı sohbet",
			report_issue: "Sorun bildir",
			no_conversations_yet: "Henüz konuşma yok",
			input_placeholder: "Bana istediğini sor",
			ended_conversation: "Bu konuşma sona erdi, lütfen yeni bir tane başlat",
			no_reply: "Henüz yanıt yok",
			recent_message: "Son mesaj",
			no_recent_messages: "Son mesaj yok",
			sources: "Kaynaklar",
			ai_agent: "Yapay Zeka Ajanı",
			ai_disclaimer: "Yapay zekâ asistanı hata yapabilir. Önemli bilgileri doğrulayın.",
		},
		tickets: {
			title: "Talepler",
			open: "Açık",
			in_progress: "Devam ediyor",
			waiting_on_customer: "Yanıtın bekleniyor",
			closed: "Kapalı",
			no_recent_tickets: "Son talep yok",
		},
		help: {
			title: "Yardım",
			no_articles_found: "Makale bulunamadı",
			no_collections_found: "Koleksiyon bulunamadı",
			articles_from_collection: "Koleksiyondaki makaleler",
			no_faq_found: "SSS bulunamadı",
			invalid_email: "Lütfen geçerli bir e-posta adresi girin",
			invalid_number: "Lütfen geçerli bir sayı girin",
			invalid_image: "Geçersiz resim türü (jpeg, jpg, png)",
			large_image: "Resim çok büyük (maks. 2 MB)",
		},
		file: {
			uploading: "Y\u00fckleniyor...",
			scanning: "Vir\u00fcs taramas\u0131 yap\u0131l\u0131yor...",
			ready: "G\u00f6nderilmeye haz\u0131r",
			quarantined: "Dosya engellendi \u2014 potansiyel tehdit alg\u0131land\u0131",
			scanFailed: "Tarama ba\u015far\u0131s\u0131z \u2014 tekrar deneyin",
			tooLarge: "Dosya \u00e7ok b\u00fcy\u00fck (maks. 2 MB): {name}",
			unsupportedType: "Desteklenmeyen dosya t\u00fcr\u00fc: {name}",
			rateLimited: "G\u00fcnl\u00fck y\u00fckleme limiti a\u015f\u0131ld\u0131. Yar\u0131n tekrar deneyin.",
			attachFile: "Dosya ekle",
			dragAndDrop: "Dosyalar\u0131 buraya b\u0131rak\u0131n",
			removeFile: "Dosyay\u0131 kald\u0131r",
			maxFilesReached: "En fazla {max} dosyaya izin verilir",
		},
		time: {
			just_now: "Az önce",
			today: "Bugün",
			yesterday: "Dün",
			ago: "önce",
			day: "gün",
			days: "gün",
			hour: "saat",
			hours: "saat",
			minute: "dakika",
			minutes: "dakika",
		},
	},

	ja: {
		home: {
			title: "ホーム",
			search: "検索",
			start_new_chat: "新しいチャットを開始",
			start_new_call: "新しい通話を開始",
		},
		conversations: {
			title: "会話",
			chats: "チャット",
			calls: "通話",
			live_chat: "ライブチャット",
			report_issue: "問題を報告",
			no_conversations_yet: "まだ会話はありません",
			input_placeholder: "何でも聞いてください",
			ended_conversation: "この会話は終了しました。新しい会話を開始してください",
			no_reply: "まだ返信がありません",
			recent_message: "最近のメッセージ",
			no_recent_messages: "最近のメッセージはありません",
			sources: "情報源",
			ai_agent: "AIエージェント",
			ai_disclaimer: "AIエージェントは間違えることがあります。重要な情報は確認してください。",
		},
		tickets: {
			title: "チケット",
			open: "未対応",
			in_progress: "対応中",
			waiting_on_customer: "お客様の返信待ち",
			closed: "完了",
			no_recent_tickets: "最近のチケットはありません",
		},
		help: {
			title: "ヘルプ",
			no_articles_found: "記事が見つかりません",
			no_collections_found: "コレクションが見つかりません",
			articles_from_collection: "コレクションの記事",
			no_faq_found: "FAQが見つかりません",
			invalid_email: "有効なメールアドレスを入力してください",
			invalid_number: "有効な数字を入力してください",
			invalid_image: "無効な画像形式です（jpeg, jpg, png）",
			large_image: "画像が大きすぎます（最大2MB）",
		},
		file: {
			uploading: "\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9\u4e2d...",
			scanning: "\u30a6\u30a4\u30eb\u30b9\u30b9\u30ad\u30e3\u30f3\u4e2d...",
			ready: "\u9001\u4fe1\u6e96\u5099\u5b8c\u4e86",
			quarantined: "\u30d5\u30a1\u30a4\u30eb\u304c\u30d6\u30ed\u30c3\u30af\u3055\u308c\u307e\u3057\u305f \u2014 \u6f5c\u5728\u7684\u306a\u8105\u5a01\u3092\u691c\u51fa",
			scanFailed: "\u30b9\u30ad\u30e3\u30f3\u5931\u6557 \u2014 \u3082\u3046\u4e00\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044",
			tooLarge: "\u30d5\u30a1\u30a4\u30eb\u304c\u5927\u304d\u3059\u304e\u307e\u3059\uff08\u6700\u59272MB\uff09: {name}",
			unsupportedType: "\u30b5\u30dd\u30fc\u30c8\u3055\u308c\u3066\u3044\u306a\u3044\u30d5\u30a1\u30a4\u30eb\u5f62\u5f0f: {name}",
			rateLimited: "\u65e5\u6b21\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9\u4e0a\u9650\u306b\u9054\u3057\u307e\u3057\u305f\u3002\u660e\u65e5\u518d\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044\u3002",
			attachFile: "\u30d5\u30a1\u30a4\u30eb\u3092\u6dfb\u4ed8",
			dragAndDrop: "\u3053\u3053\u306b\u30d5\u30a1\u30a4\u30eb\u3092\u30c9\u30ed\u30c3\u30d7",
			removeFile: "\u30d5\u30a1\u30a4\u30eb\u3092\u524a\u9664",
			maxFilesReached: "\u6700\u5927{max}\u30d5\u30a1\u30a4\u30eb\u307e\u3067",
		},
		time: {
			just_now: "たった今",
			today: "今日",
			yesterday: "昨日",
			ago: "前",
			day: "日",
			days: "日",
			hour: "時間",
			hours: "時間",
			minute: "分",
			minutes: "分",
		},
	},

	zh: {
		home: {
			title: "首页",
			search: "搜索",
			start_new_chat: "开始新聊天",
			start_new_call: "开始新通话",
		},
		conversations: {
			title: "对话",
			chats: "聊天",
			calls: "通话",
			live_chat: "在线聊天",
			report_issue: "报告问题",
			no_conversations_yet: "暂无对话",
			input_placeholder: "随便问我",
			ended_conversation: "此对话已结束，请开始新的对话",
			no_reply: "暂无回复",
			recent_message: "最近消息",
			no_recent_messages: "没有最近的消息",
			sources: "来源",
			ai_agent: "AI代理",
			ai_disclaimer: "AI 智能体可能会出错。请核实重要信息。",
		},
		tickets: {
			title: "工单",
			open: "未处理",
			in_progress: "处理中",
			waiting_on_customer: "等待您的回复",
			closed: "已关闭",
			no_recent_tickets: "暂无工单",
		},
		help: {
			title: "帮助",
			no_articles_found: "未找到文章",
			no_collections_found: "未找到集合",
			articles_from_collection: "集合中的文章",
			no_faq_found: "未找到常见问题",
			invalid_email: "请输入有效的电子邮件地址",
			invalid_number: "请输入有效的数字",
			invalid_image: "无效的图片类型（jpeg, jpg, png）",
			large_image: "图片过大（最大 2MB）",
		},
		file: {
			uploading: "\u4e0a\u4f20\u4e2d...",
			scanning: "\u6b63\u5728\u626b\u63cf\u75c5\u6bd2...",
			ready: "\u51c6\u5907\u53d1\u9001",
			quarantined: "\u6587\u4ef6\u5df2\u88ab\u963b\u6b62 \u2014 \u68c0\u6d4b\u5230\u6f5c\u5728\u5a01\u80c1",
			scanFailed: "\u626b\u63cf\u5931\u8d25 \u2014 \u8bf7\u91cd\u8bd5",
			tooLarge: "\u6587\u4ef6\u8fc7\u5927\uff08\u6700\u5927 2MB\uff09: {name}",
			unsupportedType: "\u4e0d\u652f\u6301\u7684\u6587\u4ef6\u7c7b\u578b: {name}",
			rateLimited: "\u5df2\u8fbe\u5230\u6bcf\u65e5\u4e0a\u4f20\u9650\u5236\u3002\u8bf7\u660e\u5929\u518d\u8bd5\u3002",
			attachFile: "\u9644\u52a0\u6587\u4ef6",
			dragAndDrop: "\u5c06\u6587\u4ef6\u62d6\u653e\u5230\u6b64\u5904",
			removeFile: "\u5220\u9664\u6587\u4ef6",
			maxFilesReached: "\u6700\u591a\u5141\u8bb8 {max} \u4e2a\u6587\u4ef6",
		},
		time: {
			just_now: "刚刚",
			today: "今天",
			yesterday: "昨天",
			ago: "前",
			day: "天",
			days: "天",
			hour: "小时",
			hours: "小时",
			minute: "分钟",
			minutes: "分钟",
		},
	},

	ar: {
		home: {
			title: "الرئيسية",
			search: "بحث",
			start_new_chat: "بدء محادثة جديدة",
			start_new_call: "بدء مكالمة جديدة",
		},
		conversations: {
			title: "المحادثات",
			chats: "الدردشات",
			calls: "المكالمات",
			live_chat: "دردشة مباشرة",
			report_issue: "الإبلاغ عن مشكلة",
			no_conversations_yet: "لا توجد محادثات بعد",
			input_placeholder: "اسألني أي شيء",
			ended_conversation: "انتهت هذه المحادثة، يرجى بدء محادثة جديدة",
			no_reply: "لا يوجد رد بعد",
			recent_message: "أحدث رسالة",
			no_recent_messages: "لا توجد رسائل حديثة",
			sources: "المصادر",
			ai_agent: "وكيل الذكاء الاصطناعي",
			ai_disclaimer: "قد يرتكب وكيل الذكاء الاصطناعي أخطاء. تحقق من المعلومات المهمة.",
		},
		tickets: {
			title: "التذاكر",
			open: "مفتوح",
			in_progress: "قيد المعالجة",
			waiting_on_customer: "بانتظار ردك",
			closed: "مغلق",
			no_recent_tickets: "لا توجد تذاكر حديثة",
		},
		help: {
			title: "المساعدة",
			no_articles_found: "لم يتم العثور على مقالات",
			no_collections_found: "لم يتم العثور على مجموعات",
			articles_from_collection: "مقالات من المجموعة",
			no_faq_found: "لم يتم العثور على أسئلة شائعة",
			invalid_email: "يرجى إدخال بريد إلكتروني صالح",
			invalid_number: "يرجى إدخال رقم صالح",
			invalid_image: "نوع صورة غير صالح (jpeg, jpg, png)",
			large_image: "حجم الصورة كبير جدًا (الحد الأقصى 2 ميجابايت)",
		},
		file: {
			uploading: "\u062c\u0627\u0631\u064a \u0627\u0644\u0631\u0641\u0639...",
			scanning: "\u062c\u0627\u0631\u064a \u0641\u062d\u0635 \u0627\u0644\u0641\u064a\u0631\u0648\u0633\u0627\u062a...",
			ready: "\u062c\u0627\u0647\u0632 \u0644\u0644\u0625\u0631\u0633\u0627\u0644",
			quarantined: "\u062a\u0645 \u062d\u0638\u0631 \u0627\u0644\u0645\u0644\u0641 \u2014 \u062a\u0645 \u0627\u0643\u062a\u0634\u0627\u0641 \u062a\u0647\u062f\u064a\u062f \u0645\u062d\u062a\u0645\u0644",
			scanFailed: "\u0641\u0634\u0644 \u0627\u0644\u0641\u062d\u0635 \u2014 \u062d\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649",
			tooLarge: "\u0627\u0644\u0645\u0644\u0641 \u0643\u0628\u064a\u0631 \u062c\u062f\u064b\u0627 (\u0627\u0644\u062d\u062f \u0627\u0644\u0623\u0642\u0635\u0649 2 \u0645\u064a\u062c\u0627\u0628\u0627\u064a\u062a): {name}",
			unsupportedType: "\u0646\u0648\u0639 \u0645\u0644\u0641 \u063a\u064a\u0631 \u0645\u062f\u0639\u0648\u0645: {name}",
			rateLimited: "\u062a\u0645 \u0628\u0644\u0648\u063a \u0627\u0644\u062d\u062f \u0627\u0644\u064a\u0648\u0645\u064a. \u062d\u0627\u0648\u0644 \u063a\u062f\u064b\u0627.",
			attachFile: "\u0625\u0631\u0641\u0627\u0642 \u0645\u0644\u0641",
			dragAndDrop: "\u0623\u0641\u0644\u062a \u0627\u0644\u0645\u0644\u0641\u0627\u062a \u0647\u0646\u0627",
			removeFile: "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0644\u0641",
			maxFilesReached: "\u0627\u0644\u062d\u062f \u0627\u0644\u0623\u0642\u0635\u0649 {max} \u0645\u0644\u0641\u0627\u062a",
		},
		time: {
			just_now: "الآن",
			today: "اليوم",
			yesterday: "أمس",
			ago: "منذ",
			day: "يوم",
			days: "أيام",
			hour: "ساعة",
			hours: "ساعات",
			minute: "دقيقة",
			minutes: "دقائق",
		},
	},

	he: {
		home: {
			title: "דף הבית",
			search: "חיפוש",
			start_new_chat: "התחלת צ׳אט חדש",
			start_new_call: "התחלת שיחה חדשה",
		},
		conversations: {
			title: "שיחות",
			chats: "צ׳אטים",
			calls: "שיחות",
			live_chat: "צ׳אט חי",
			report_issue: "דווח על בעיה",
			no_conversations_yet: "אין שיחות עדיין",
			input_placeholder: "שאל אותי כל דבר",
			ended_conversation: "השיחה הסתיימה, אנא התחל שיחה חדשה",
			no_reply: "אין תגובה עדיין",
			recent_message: "הודעה אחרונה",
			no_recent_messages: "אין הודעות אחרונות",
			sources: "מקורות",
			ai_agent: "סוכן בינה מלאכותית",
			ai_disclaimer: "סוכן ה-AI עלול לטעות. יש לאמת מידע חשוב.",
		},
		tickets: {
			title: "פניות",
			open: "פתוח",
			in_progress: "בטיפול",
			waiting_on_customer: "ממתין לתגובתך",
			closed: "סגור",
			no_recent_tickets: "אין פניות אחרונות",
		},
		help: {
			title: "עזרה",
			no_articles_found: "לא נמצאו מאמרים",
			no_collections_found: "לא נמצאו אוספים",
			articles_from_collection: "מאמרים מהאוסף",
			no_faq_found: "לא נמצאו שאלות נפוצות",
			invalid_email: "אנא הזן כתובת אימייל תקינה",
			invalid_number: "אנא הזן מספר תקין",
			invalid_image: "סוג תמונה לא חוקי (jpeg, jpg, png)",
			large_image: "התמונה גדולה מדי (מקסימום 2MB)",
		},
		file: {
			uploading: "\u05de\u05e2\u05dc\u05d4...",
			scanning: "\u05e1\u05d5\u05e8\u05e7 \u05dc\u05d5\u05d5\u05d9\u05e8\u05d5\u05e1\u05d9\u05dd...",
			ready: "\u05de\u05d5\u05db\u05df \u05dc\u05e9\u05dc\u05d9\u05d7\u05d4",
			quarantined: "\u05d4\u05e7\u05d5\u05d1\u05e5 \u05e0\u05d7\u05e1\u05dd \u2014 \u05d6\u05d5\u05d4\u05d4 \u05d0\u05d9\u05d5\u05dd \u05e4\u05d5\u05d8\u05e0\u05e6\u05d9\u05d0\u05dc\u05d9",
			scanFailed: "\u05d4\u05e1\u05e8\u05d9\u05e7\u05d4 \u05e0\u05db\u05e9\u05dc\u05d4 \u2014 \u05e0\u05e1\u05d4 \u05e9\u05d5\u05d1",
			tooLarge: "\u05d4\u05e7\u05d5\u05d1\u05e5 \u05d2\u05d3\u05d5\u05dc \u05de\u05d3\u05d9 (\u05de\u05e7\u05e1\u05d9\u05de\u05d5\u05dd 2MB): {name}",
			unsupportedType: "\u05e1\u05d5\u05d2 \u05e7\u05d5\u05d1\u05e5 \u05dc\u05d0 \u05e0\u05ea\u05de\u05da: {name}",
			rateLimited: "\u05d4\u05d2\u05e2\u05ea \u05dc\u05de\u05d2\u05d1\u05dc\u05d4 \u05d4\u05d9\u05d5\u05de\u05d9\u05ea. \u05e0\u05e1\u05d4 \u05de\u05d7\u05e8.",
			attachFile: "\u05e6\u05e8\u05e3 \u05e7\u05d5\u05d1\u05e5",
			dragAndDrop: "\u05d2\u05e8\u05d5\u05e8 \u05e7\u05d1\u05e6\u05d9\u05dd \u05dc\u05db\u05d0\u05df",
			removeFile: "\u05d4\u05e1\u05e8 \u05e7\u05d5\u05d1\u05e5",
			maxFilesReached: "\u05de\u05e7\u05e1\u05d9\u05de\u05d5\u05dd {max} \u05e7\u05d1\u05e6\u05d9\u05dd",
		},
		time: {
			just_now: "הרגע",
			today: "היום",
			yesterday: "אתמול",
			ago: "לפני",
			day: "יום",
			days: "ימים",
			hour: "שעה",
			hours: "שעות",
			minute: "דקה",
			minutes: "דקות",
		},
	},
};
